import React from 'react';
import Button from '../General/Button';
import Link from 'next/link';
import helpers from '../../utils/helpers';

function MarketBeats() {
    return (
        <div id='market-beating-exclusive-price' className='--align py-10 lg:py-[95px]' style={{ background : 'rgba(229, 233, 241, 0.4)' }}>
            <div className='md:flex md:flex-row-reverse md:justify-between md:items-center'>
                <div className='md:w-[50%] lg:w-[39%]'>
                    <img className='w-full md:w-full' src="/Home/MarketBeating.svg" alt="QuickDelivery" loading='lazy'/>
                </div>

                <div className='mt-[20px] md:w-[40%] lg:w-[48%]'>
                    <h5 className='text-dark-saffron text-[24px] font-semibold lg:text-[36px] font-[600]'>Market-Beating Exclusive Price</h5>

                    <p className='text-[#333333] font-[300] lg:font-[200] text-[14px] mt-3 lg:text-[20px]'>
                        The unique demand aggregation model of APIdrug.com gives us high negotiating power. 
                        With strong supplier relationships, APIdrug sources the best prices and often holds 
                        inventory at different locations globally, for fast-moving molecules. 
                        That’s how we get you the best deals without compromising on product quality.
                    </p>

                    <div className='flex justify-between items-center mt-[34px] lg:justify-start'>
                        <p onClick={() => helpers.scrollTo('enquiry-section', 140)} className='w-[48%] lg:w-[193px] lg:mr-[20px]'>
                            <Button styles = "bg-white text-theme-orange border border-theme-orange w-full h-[42px] lg:h-[54px] font-[400] lg:text-[18px]">
                                Open Bulk Deals
                            </Button>
                        </p>
                        <Link href={'/spot-buying'} className='w-[48%] lg:w-[193px]'>
                            <Button styles = "text-white bg-theme-orange w-full h-[42px] lg:h-[54px] font-[500] lg:text-[18px]">
                                Open Spot Prices
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MarketBeats